import { useQuery } from '@tanstack/react-query';
import { activityService } from '@services/activity';

export const PENDING_INVOICES_COUNT_QUERY_KEY = 'pending-invoices-count';

// Count of ACTIVE pending-invoice activities across the given projects. Backs the
// dashboard invoice triage pill (hidden when 0).
//
// Kept live by useOrganizationEventsSubscription rather than a poll. This one is
// why the channel carries a signal instead of a payload: the count is derived
// from the caller's own `projectsId`, so no single pushed value would be correct
// for every subscriber — each client has to refetch with its own arguments.
export const usePendingInvoicesCount = (projectsId: string[]) => {
  return useQuery({
    queryKey: [PENDING_INVOICES_COUNT_QUERY_KEY, projectsId?.slice().sort()],
    queryFn: () => activityService.getPendingInvoicesCountByProjects(projectsId),
    enabled: Boolean(projectsId && projectsId.length > 0 && projectsId[0]),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
};

export default usePendingInvoicesCount;
